<ion-item>

  <ion-thumbnail slot="start">
    @if(!!item.imagen) {
      <img [src]="item.imagen" alt="">

    } @else {
      <yu-icon name="bell" color="medium"></yu-icon>
    }
  </ion-thumbnail>

  <ion-label>

    <div class="data">
      @if(!item.vista) {
        <yu-badge type="dot"></yu-badge>
      }

      <div class="title">{{ item.titulo }}</div>

      <div class="date">{{ item.fecha_u + '000' | date: 'dd MMM HH:mm' }}</div>
    </div>

    <div class="message ion-text-wrap" [innerHTML]="item.mensaje"></div>

  </ion-label>

</ion-item>
